export interface ProductSearch {
  name: string
  slug: string
}

export const minSearchText = 3
